import { OnBoarding } from './on-boarding.types';

export const setOrderDetails = (data) => ({
    type: OnBoarding.SET_ORDER_DETAILS,
    payload: data
})

export const setUpdatedDetails = (data) => ({
    type: OnBoarding.SET_UPDATED_DETAILS,
    payload: data
})

export const setUniqueRefNo = (data) => ({
    type: OnBoarding.SET_UNIQUE_REF_NO,
    payload: data
})

export const setRblUniqueRefNo = (data) => ({
    type: OnBoarding.SET_RBL_UNIQUE_REF_NO,
    payload: data
})

export const showCurrentState = () =>({
    type: OnBoarding.SET_CURRENT_STATE  
})
  
export const showPreviousState = () =>({
    type: OnBoarding.SET_PREVIOUS_STATE
})

export const resetOnBoarding ={
    type: OnBoarding.RESET
  }